// cs2669 (Daniel, 29/10): o botão "Anuncie Seu Imóvel" da seção "Quem somos" (abaixo de "Faça parte da rede")
// vira "Quero mais informações" e leva à página /quero-mais-informacoes: formulário com nome e telefone (com DDD)
// e, só depois de preenchido, o lead segue para o WhatsApp do corretor com os dados na mensagem.
// Pedido de um cliente só = gate por codsite: fora daqui o botão segue "Anuncie Seu Imóvel" direto no
// WhatsApp, como antes, e a rota responde 404.
import { anuncieWhatsAppDoSite } from './anuncieWhatsApp';

export const QUERO_MAIS_INFORMACOES_ROTA = '/quero-mais-informacoes';

const QUERO_MAIS_INFORMACOES_SITES = new Set([2669]);

export const temQueroMaisInformacoes = (site: any): boolean =>
    QUERO_MAIS_INFORMACOES_SITES.has(Number(site?.id));

// Mesmo destino do botão "Anuncie Seu Imóvel" (OwnersPieces): número próprio do anuncie, senão tel1/tel2.
export const whatsAppDoQueroMaisInformacoes = (site: any): string | null => {
    const proprio = anuncieWhatsAppDoSite(site);
    if (proprio) return proprio;
    const digitos = String(site?.Dados?.tel1 || site?.Dados?.tel2 || '').replace(/\D/g, '');
    return digitos ? `55${digitos}` : null;
};
